<template>
    <div class="login-dialog" @click="closeDialog">
        <div class="login-wrapper" @click.stop>
            <main class="login-wrapper__main">
                <!-- 登录 -->
                <Login @closeDialog="closeDialog" @changePage="changePage" v-if="status === 0" />
                <!-- 注册 -->
                <Register @changePage="changePage" @closeDialog="closeDialog" v-if="status === 1" />
                <!-- 忘记密码 -->
                <ForgetPassword @changePage="changePage" @closeDialog="closeDialog" v-if="status === 3" />
            </main>

            <div class="close-control" @click="closeDialog">
                <svg-icon icon-class="close" class-name="icon-close"></svg-icon>
            </div>
        </div>
    </div>
</template>

<script>
import Login from './Login';
import Register from './Register';
import ForgetPassword from './ForgetPassword';

export default {
    name: 'LoginDialog',
    components: {
        Login,
        Register,
        ForgetPassword
    },
    props: {
        type: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            status: 0,
            forgetPassword: {
                email: ''
            },
            forgetPasswordRules: {
                email: [
                    { required: true, message: '请输入国内邮箱', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的国内邮箱地址', trigger: ['blur', 'change'] }
                ]
            },
            forgetBtnLoading: false
        };
    },
    mounted() {
        this.changePage(this.type);
    },
    methods: {
        closeDialog() {
            this.$emit('closeDialog');
        },
        changePage(type) {
            this.status = type;
        }
    }
};
</script>

<style lang="scss" scoped>
.login-dialog {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 999;
    background-color: rgba(0, 0, 0, 0.35);

    .login-wrapper {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        width: 400px;
        padding: 36px 40px;
        background-color: #fff;
        border-radius: 10px;
        overflow: hidden;

        &__main {
            position: relative;
            width: 100%;
            height: 100%;
            box-sizing: border-box;
            overflow: hidden;
        }

        .close-control {
            position: absolute;
            top: 20px;
            right: 25px;
            cursor: pointer;

            .icon-close {
                font-size: 15px;
                color: rgba(47, 84, 235, 0.5);

                &:hover {
                    color: rgba(47, 84, 235, 0.8);
                }
            }
        }
    }
}
</style>
